import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"8px","display":"flex","flex-direction":"row"} }
const _hoisted_2 = { class: "progressBarText" }




export default /*@__PURE__*/_defineComponent({
  __name: 'RateBar',
  props: {
    rateNum: {
        type: Number,
         default: () => 0,
    },
    percentage: {
        type: Number,
         default: () => 0,
    }

},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_progress = _resolveComponent("van-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.rateNum), 1),
    _createVNode(_component_van_progress, {
      style: {"width":"100%","height":"7px"},
      "show-pivot": false,
      color: "#01875f",
      percentage: __props.percentage,
      height: "8"
    }, null, 8, ["percentage"])
  ]))
}
}

})